import React from "react";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";
import PropTypes from "prop-types";
import { imagesMap, OG_IMAGE_TYPES, OGImage } from "../og-image";
import { staticAssetUrl } from "../../../utils/static-assets-url";
import { NUMBER } from "../../../constants/app-constants";

const EChallanMetaTags = ({
    history,
    metaTitle = "Check Traffic Challan Status & Pay e-Challan Online: CARS24",
    metaDescription = "Conveniently check and pay your traffic challan online. Clear all pending traffic challans with our hassle-free online payment system, saving you valuable time and effort."
    // bannerImageUrl = "https://fastly-production.24c.in/cars24/seo/static/53_20230802_1690958801.png"
}) => {
    const baseUrl = `${appUrl()}/`;
    const pageUrl = `${appUrl()}${history.location.pathname.replace(/\/$/, "")}/`;

    return (
        <React.Fragment>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="title" content={metaTitle} />
                <meta name="description" content={metaDescription} />
                <meta name="ROBOTS" content="INDEX,FOLLOW" />
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:url" content={`${pageUrl}`} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="CARS24" />
                <link href={pageUrl} rel="canonical" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta property="twitter:domain" content={`${baseUrl}`} />
                <meta property="twitter:url" content={pageUrl} />
                <meta name="twitter:title" content={metaTitle} />
                <meta name="twitter:description" content={metaDescription} />
                <meta name="twitter:image" content={staticAssetUrl(imagesMap.challan[NUMBER.TWO].path)}/>
            </Helmet>
            <OGImage type={OG_IMAGE_TYPES.challan} />
        </React.Fragment>
    );
};

EChallanMetaTags.propTypes = {
    history: PropTypes.object,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
    bannerImageUrl: PropTypes.string
};

export default EChallanMetaTags;
